<div class="content-wrapper">
  <markant-platform-ui-page-header>
    {{ 'dashboardOverview.cards.variantsOverview.headline' | transloco }}
  </markant-platform-ui-page-header>

  <div
    *ngIf="cartridgeIdToCartridgeDTOs$ | async as cartridgeIdToCartridgeDTOs"
  >
    <markant-expansion-panel multi="true" showIndicator="true">
      <markant-expansion-panel-item
        *ngFor="
          let keyValues of cartridgeIdToCartridgeDTOs | keyvalue;
          trackBy: trackByFn
        "
        variant="bordered"
      >
        <div slot="header" class="expansion-panel-header">
          <div class="title">
            {{ keyValues.value[0].name }} ({{ keyValues.value.length }})
          </div>
        </div>
        <div slot="content">
          <markant-list dense="false" two-lines leading-avatar="false">
            <ng-container
              *ngFor="let variant of keyValues.value; last as isLast"
            >
              <markant-list-item
                [routerLink]="['./' + variant['variantId']]"
                class="content-list-item"
              >
                <div
                  slot="markant-list-item-primary"
                  class="content-list-item-header"
                >
                  <span>
                    {{ variant['variantName'] }}
                  </span>
                </div>
                <div
                  slot="markant-list-item-secondary"
                  class="content-list-item-content"
                >
                  <span>
                    <div [innerHTML]="variant['variantDescription']"></div>
                  </span>
                </div>
                <markant-icon
                  slot="markant-list-item-trailing"
                  icon="m_chevron-right"
                ></markant-icon>
              </markant-list-item>
              <markant-list-divider *ngIf="!isLast"></markant-list-divider>
            </ng-container>
          </markant-list>
        </div>
      </markant-expansion-panel-item>
    </markant-expansion-panel>
  </div>
</div>
